module.exports = __webpack_public_path__ + "media/יד.557d2d76.mp3";